<template>
    <div>
        <div
            v-if="windowWidth >= 768 || !carouselPhone"
            :class="['gallery-grid', { 'grid-desktop': gridDesktop }]">
            <div
                v-for="(thumbnail, index) in thumbnails"
                :key="index">
                <figure
                    class="thumb-figure"
                    :style="cssVars"
                    @click="lightboxEffect(index)">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="white">
                        <path
                            d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3 17v-10l9 5.146-9 4.854z" />
                    </svg>
                    <img
                        v-if="index < 6"
                        :src="
                            !!thumbnail.image
                                ? thumbnailsPath + thumbnail.image
                                : thumbnailsPath + thumbnail
                        "
                        class="light-box__thumbnail" />
                    <img
                        v-else
                        :src="thumbnail.image"
                        class="light-box__thumbnail" />
                </figure>
                <p
                    v-if="thumbnail.description"
                    class="light-box__thumbnail-description">
                    {{ thumbnail.description }}
                </p>
                <div
                    v-if="thumbnail.download"
                    class="light-box__thumbnail-download">
                    <p>Download</p>
                    <a
                        :href="thumbnail.download"
                        download>
                        .MP4
                    </a>
                </div>
            </div>
        </div>
        <Carousel
            v-else-if="windowWidth < 768 && carouselPhone"
            :per-page="1"
            :touch-drag="true"
            pagination-active-color="#0084ff"
            pagination-color="#555d62"
            :pagination-size="10"
            :pagination-padding="5">
            <Slide
                v-for="(image, index) in thumbnails"
                :key="index">
                <figure
                    :class="[
                        'thumb-figure',
                        { 'thumb-figure-phone': windowWidth < 768 && carouselPhone }
                    ]"
                    @click="lightboxEffect(index)">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="white">
                        <path
                            d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3 17v-10l9 5.146-9 4.854z" />
                    </svg>
                    <img
                        v-if="index < 6"
                        :src="thumbnailsPath + image.image"
                        class="light-box__thumbnail" />
                    <img
                        v-else
                        :src="image.image"
                        class="light-box__thumbnail" />
                </figure>
            </Slide>
        </Carousel>

        <transition
            name="fade"
            mode="out-in">
            <div
                v-if="bg"
                class="light-box__bg"
                @click.stop="bg = !bg" />
        </transition>

        <div
            v-if="bg"
            class="cont">
            <TintableImage
                :url="require('../../static/img/BtnClose.png')"
                class="return-button"
                @click="bg = !bg" />
            <div
                class="light-box__close"
                @click.stop="bg = !bg" />

            <div
                v-if="false"
                class="light-box__prev light-box__btn"
                @click="prev">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    fill="white">
                    <path
                        d="M20 .755l-14.374 11.245 14.374 11.219-.619.781-15.381-12 15.391-12 .609.755z" />
                </svg>
            </div>

            <div
                v-if="bg"
                class="light-box__container">
                <transition
                    name="fade"
                    mode="out-in">
                    <img
                        v-if="imgGallery"
                        :src="largePath + [currentImage + 1] + '.png'"
                        alt="the sandbox" />
                    <video
                        v-if="videoGallery"
                        class="light-box__container__img"
                        autoplay
                        controls>
                        <source
                            :src="largePath + [currentImage + 1] + '.mp4'"
                            type="video/mp4" />
                    </video>
                    <iframe
                        v-if="youtube"
                        :src="
                            'https://www.youtube.com/embed/' +
                                youtubeId[currentImage] +
                                '?showinfo=0&enablejsapi=1&rel=0&autoplay=1'
                        "
                        frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                        autoplay />
                </transition>
            </div>
            <div
                v-if="false"
                class="light-box__next light-box__btn"
                @click="next">
                <svg
                    width="24"
                    height="24"
                    xmlns="http://www.w3.org/2000/svg"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    fill="white">
                    <path
                        d="M4 .755l14.374 11.245-14.374 11.219.619.781 15.381-12-15.391-12-.609.755z" />
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
import TintableImage from '@/components/press/TintableImage.vue'

export default {
    components: {
        TintableImage,
        Carousel,
        Slide
    },
    props: {
        imgGallery: { type: Boolean, default: false },
        videoGallery: { type: Boolean, default: false },
        youtube: { type: Boolean, default: false },
        gridDesktop: { type: Boolean, default: false },
        dimension: {
            type: Object,
            default: () => {
                return {
                    width: 270,
                    height: 150
                }
            }
        },
        youtubeId: {
            type: Array,
            default: function () {
                return []
            }
        },
        thumbnails: {
            type: Array,
            default: function () {
                return []
            }
        },
        large: {
            type: Array,
            default: function () {
                return []
            }
        },
        thumbnailsPath: {
            type: String,
            default: ''
        },
        thumbnailsDescription: {
            type: Array,
            default: function () {
                return []
            }
        },
        largePath: {
            type: String,
            default: ''
        },
        captions: {
            type: Array,
            required: true,
            default: function () {
                return []
            }
        },
        carouselPhone: { type: Boolean, default: false }
    },
    data () {
        return {
            bg: false,
            currentImage: 0,
            count: true,
            caption: true,
            windowWidth: null
        }
    },
    computed: {
        cssVars () {
            return {
                '--width': `${this.dimension.width}px`,
                '--height': `${this.dimension.height}px`,
                '--grid-desktop': `${this.gridDesktop}`
            }
        }
    },
    created () {
        if (process.client) {
            window.addEventListener('keyup', e => {
                if (e.key === 'Escape') {
                    this.closeVideo()
                }
            })
        }
    },
    mounted () {
        this.windowWidth = window.innerWidth
        window.addEventListener('resize', this.onResize)
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.onResize)
    },
    destroyed () {
        if (process.client) {
            this.closeVideo()
        }
    },
    methods: {
        onResize () {
            this.windowWidth = window.innerWidth
        },
        closeVideo () {
            this.bg = false
        },
        lightboxEffect (curr) {
            this.currentImage = curr
            this.bg = !this.bg
        },
        next () {
            if (this.currentImage < this.largeImages.length - 1) {
                this.currentImage++
            } else {
                this.currentImage = 0
            }
        },
        prev () {
            if (this.currentImage > 0) {
                this.currentImage--
            } else {
                this.currentImage = this.largeImages.length - 1
            }
        }
    }
}
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0;
}
.gallery-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  &.grid-desktop {
    @include breakpoint($device: desktop) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
  gap: 40px 40px;
  @include breakpoint($max: desktop-md) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @include breakpoint($max: tablet) {
    grid-template-columns: 1fr 1fr;
  }
  @include breakpoint($device: mobile) {
    grid-template-columns: 1fr;
  }
  & > div {
    max-width: 330px;
    justify-self: center;
    align-self: center;
    min-height: 150px;
  }
  & > div > p {
    margin-top: 15px;
    word-break: break-word;
  }
}
.cont {
  display: flex;
}

.return-button {
  cursor: pointer;
  position: fixed;
  top: 90px;
  right: 30px;
  width: 30px;
  height: 30px;
  background-color: $grey-10;
  z-index: 1000;
  @include breakpoint($device: mobile) {
    cursor: pointer;
    top: 11px;
    right: 11px;
    width: 15px;
    height: 15px;
  }
  &.back {
    width: 23px;
    height: 23px;
  }
}

.return-button:hover {
  background-color: white;
}
iframe {
  width: 1229px;
  height: 691px;
  @include breakpoint($max: tablet) {
    width: 640px;
    height: 360px;
  }
  @include breakpoint($device: mobile) {
    width: 320px;
    height: 240px;
  }
}
.thumb-figure {
  position: relative;
  width: var(--width);
  height: var(--height);
  box-shadow: 0px 3px 6px #00000038;
  border-radius: 30px;
  justify-self: center;
  align-self: center;
  img {
    width: 100%;
    @if var(--height) != 270 {
      height: 100%;
    } @else {
      height: auto;
    }
  }
  svg {
    position: absolute;
    width: 70px;
    height: 70px;
    @if var(--height) != 270 {
      top: calc((var(--height) / 2) - (70px / 2));
      left: calc((var(--width) / 2) - (70px / 2));
    } @else {
      top: calc((height / 2) - (70px / 2));
      left: calc((width / 2) - (70px / 2));
    }
    background: rgba(0, 0, 0, 0.2);
    border-radius: 50%;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.light-box {
  &__bg {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.89);
    z-index: 2000;
  }
  &__thumbnail {
    cursor: pointer;
    justify-self: center;
    align-self: center;
    border-radius: 30px;
  }
  &__thumbnail-description {
    color: white;
    font-family: "Montserrat Bold", sans-serif;
    font-size: 22px;
    text-align: left;
    font-weight: 600;
    line-height: 25px;
  }
  &__thumbnail-download {
    @include flex(row, center, flex-start);
    margin-top: 10px;
    @include breakpoint($max: tablet) {
      margin-top: 0px;
    }
    p {
      color: $gray11;
      font-size: 18px;
      font-weight: bold;
    }
    a {
      margin-left: 20px;
      text-decoration: none;
      color: $blue-2;
      font-weight: bold;
    }
  }
  $image-close: url('../../static/img/BtnClose.png');
  &__close {
    padding: 10px;
    position: absolute;
    right: 20px;
    top: 20px;
    background-image: $image-close;
    background-size: contain;
    background-position: center;
    z-index: 2001;
  }
  &__container {
    z-index: 2000 !important;
    max-width: 100% !important;
    right: 0;
    top: 0 !important;
    width: 100%;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    img {
      align-self: center;
    }
    video {
      width: 100%;
      height: 100%;
    }
  }
  &__btn {
    background-size: contain;
    background-position: center;
    align-self: center;
    padding: 15px;
  }
  &__close,
  &__btn {
    cursor: pointer;
  }
  &__close,
  &__btn,
  &__caption,
  &__count {
    position: fixed;
    z-index: 3000;
  }
  &__next {
    background-image: url(/img/lightbox/next.svg);
    right: 20px;
  }
  &__prev {
    background-image: url(/img/lightbox/prev.svg);
    left: 20px;
  }
  &__next,
  &__prev {
    top: 45%;
  }
  &__caption {
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 20px;
    justify-content: center;
  }
  &__count {
    left: 20px;
    font-size: 16px;
    color: #fff;
    top: 14px;
    padding: 0;
    margin: 0;
  }
}

.VueCarousel {
  width: 100%;
}

.VueCarousel-slide {
  @include flex(row, center, center);
}

.thumb-figure-phone {
  width: 270px;
  height: 150px;
  box-shadow: 0px 3px 6px #00000038;
  @include flex(row, center, center);
  img {
    width: 100%;
  }
  svg {
    position: absolute;
    width: 70px;
    height: 70px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 50%;
  }
}
</style>
